<template>
  <v-list dense v-if="selectedItem" density="compact">
    <v-list-group v-for="(child, index) in childrenWith" :key="`group-${index}`" no-action :value="true">
      <template v-slot:activator>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>{{ $store.getters.t(child.title) }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </template>
      <v-list-item v-for="(grandchild, i) in child.children" :key="`grandchild-${i}`" :to="grandchild.to">
        <v-list-item-content>
          <v-list-item-title>{{ $store.getters.t(grandchild.title) }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list-group>

    <v-list-item v-for="(child, index) in childrenWithout" :key="`item-${index}`" :to="child.to" class="ma-2 ml-1 mt-0">
      <v-list-item-content>
        <v-list-item-title>{{ $store.getters.t(child.title) }}</v-list-item-title>
      </v-list-item-content>
    </v-list-item>
  </v-list>
</template>




<script>
export default {
  props: ['selectedItem'],
  data() {
    return {
      mini: true,
      miniMode: true,
    };
  },
  methods: {
    handleChildClick(grandchild) {
      if (grandchild.to) {
        this.$router.push(grandchild.to);
        this.$emit('mini', true);
      }
    },
    hasGrandchildren(child) {
      return child.children && child.children.length > 0;
    },
  },
  computed: {
    childrenWith() {
      return this.selectedItem?.children?.filter(c => c.children && c.children.length) || [];
    },
    childrenWithout() {
      return this.selectedItem?.children?.filter(c => !c.children || !c.children.length) || [];
    },
  },
  watch: {
    selectedItem(newVal, oldVal) {
    }
  },


};
</script>
